'use strict';

angular.module('shop').component('productList', {
	templateUrl: 'component/product-list.html',
	bindings: {
		products: '<',
		category: '<'
	},
	controller: function() {
		var self = this;

		this.filteredProducts = function() {
			if (!self.category) {
				return self.products;
			}

			// Filter out products based on active category
			return _.filter(self.products, function(product) {
				return _.findIndex(product.searchGroupsArticle, {searchGroup: self.category}) !== -1; 
			});
		};
	}
});